export enum IbanAccountType {
    CHECKING_ACCOUNT = 'checking_account',
    SAVINGS_ACCOUNT = 'savings_account',
}

export const IBAN_ACCOUNT_TYPE_LABELS: Record<IbanAccountType, string> = {
    [IbanAccountType.CHECKING_ACCOUNT]: 'Zichtrekening',
    [IbanAccountType.SAVINGS_ACCOUNT]: 'Spaarrekening',
};

export interface CompanyIban {
    id?: number;
    companyId?: number;
    iban: string;
    bank?: string | null;
    type: IbanAccountType;
    isDefaultForRentPayments: boolean;
}

export const BELGIAN_BANK_SUGGESTIONS: string[] = [
    "KBC",
    "BNP Paribas Fortis",
    "Belfius",
    "AXA",
    "Crelan",
    "ING",
    "Bpost Bank",
    "Argenta",
    "Beobank",
];

export type YallyCompany = {
    id: number;
    name: string;
    legalForm: CompanyLegalForm;
    kbo: string;
    number_professional_seller: string;
    googlePlaceLongAddress: string;
    googlePlaceId: string;
    vat: string;
    houseNr: string;
    box: string;
    odooId?: number;
    ibanRentDeposit?: string;
    companyIbans?: CompanyIban[];

    // Corporate fields
    foundingDate?: string;
    totalShares?: number;
    leiCode?: string;
    peppolCode?: string;
    jointCommittee?: string;
    socialSecurityNumber?: string;
    nacebelCodes?: string[];
    fiscalYearStartDay?: string;
    fiscalYearEndDay?: string;
    generalMeetingDate?: string;
    cevora?: string;

    // Contact FK fields
    auditorContactId?: number;
    auditorContact?: CompanyShareholder['contact'];
    auditorMandateStartDate?: string;
    auditorMandateEndDate?: string;
    medicalSupervisorContactId?: number;
    medicalSupervisorContact?: CompanyShareholder['contact'];

    // Relations
    shareholders?: CompanyShareholder[];
    directors?: CompanyDirector[];
    employees?: CompanyEmployee[];
}

export interface CompanyShareholder {
    id?: number;
    contact?: {
        id: number;
        firstName: string;
        lastName: string;
    };
    contactCompany?: {
        id: number;
        name: string;
    };
    numberOfShares?: number;
}

export interface CompanyDirector {
    id?: number;
    contact?: {
        id: number;
        firstName: string;
        lastName: string;
    };
    contactCompany?: {
        id: number;
        name: string;
    };
    representative?: {
        id: number;
        firstName: string;
        lastName: string;
    };
    role?: string;
}

export interface CompanyEmployee {
    id: number;
    firstName: string;
    lastName: string;
}

export enum CompanyLegalForm {
    NV = 'NV',
    BVBA = 'BVBA',
    BV = 'BV'
}